module.exports = __webpack_public_path__ + "static/media/18ECA26.a65e62d9.jpg";